import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import './app.css';
import { provide } from '@servicetitan/react-ioc';
import { MarketingUrl } from './enums/marketing-url';
import { MainPage } from './components/main-page/main-page';
import { ErrorPage } from './components/error-page/error-page';
import { SubscriptionStore } from './stores/subscription.store';
import { UnsubscribeApi as Unsubscribe } from './api/unsubscribe.api';
import { SubscriptionPreferencesApi as SubscriptionPreferences } from './api/subscription-preferences.api';
import { OptInApi as OptIn } from './api/optin.api';
import '../assets/less/styles.module.less';
import { ValidationApi as Validation } from './api/validation.api';
import { UnsubscribePage } from './unsubscribe-page/page/unsubscribe-page';
import { PreferencesPage } from './components/preferences-page/preferences-page';
import { OptInPage } from './opt-in-page/page/opt-in-page';

export const App: FC = provide({
    singletons: [Unsubscribe, SubscriptionPreferences, OptIn, Validation, SubscriptionStore],
})(() => (
    <Routes>
        <Route path={MarketingUrl.Test} element={<MainPage />} />
        <Route path={MarketingUrl.Unsubscribe} element={<UnsubscribePage />} />
        <Route path={MarketingUrl.Preferences} element={<PreferencesPage />} />
        <Route path={MarketingUrl.OptIn} element={<OptInPage />} />
        <Route path={MarketingUrl.Error} element={<ErrorPage type="not-found" />} />
        <Route path="*" element={<ErrorPage type="not-found" />} />
    </Routes>
));
